import { withNestedView } from '@/router/routerHelpers';
const loadView = withNestedView('settings');

const settingsRoutes = [
  {
    path: '/settings',
    component: {
      render: (c) => c('router-view'),
    },
    children: [
      {
        path: '',
        meta: { showNav: true },
        component: loadView('Settings'),
        children: [
          {
            path: 'profile',
            name: 'settings-profile',
            component: loadView('users/components/UserEditForm'),
          },
          {
            path: 'users',
            name: 'settings-users',
            meta: {
              feature: 'users',
              permission: 'read_users',
            },
            component: loadView('users/UsersMain'),
          },
          {
            path: 'archived-users',
            name: 'settings-archived-users',
            props: { archived: true },
            meta: {
              feature: 'archived_users',
              permission: 'read_users',
            },
            component: loadView('users/UsersMain'),
          },
          {
            path: 'account',
            name: 'settings-account',
            meta: {
              feature: 'account',
            },
            component: loadView('account/Account'),
          },
          {
            path: 'snippets',
            name: 'settings-snippets',
            redirect: { name: 'snippets' },
          },
          {
            path: 'fields',
            name: 'settings-fields',
            meta: {
              feature: 'fields',
            },
            component: loadView('fields/FieldsMain'),
          },
          {
            path: 'links',
            name: 'settings-links',
            meta: {
              feature: 'links',
            },
            component: loadView('links/SettingsLinks'),
          },
          {
            path: 'portal',
            name: 'settings-portal',
            component: loadView('portal/SettingsPortal'),
          },
          {
            path: 'integrations',
            name: 'settings-integrations',
            meta: {
              feature: 'integrations',
            },
            component: loadView('integrations/Integrations'),
          },
          {
            path: 'email-templates',
            name: 'settings-email-templates',
            meta: {
              feature: 'email_templates',
            },
            component: loadView('emailTemplates/EmailTemplatesMain'),
          },
          {
            path: 'email-addresses',
            name: 'settings-email-addresses',
            meta: {
              feature: 'email_addresses',
            },
            component: loadView('emailAddresses/EmailAddressesMain'),
          },
          {
            path: 'business',
            name: 'settings-business',
            meta: {
              feature: 'other_settings',
            },
            component: loadView('other/SettingsBusiness'),
          },
          {
            path: 'conversations',
            name: 'settings-conversations',
            meta: {
              feature: 'other_settings',
            },
            component: loadView('other/SettingsConversations'),
          },
          {
            path: 'okta',
            name: 'settings-okta',
            meta: {
              feature: 'okta_auth',
            },
            component: loadView('other/SettingsOkta'),
          },
          {
            path: 'other/:section?',
            props: true,
            name: 'settings-other',
            meta: { feature: 'settings' },
            component: loadView('other/SettingsOther'),
          },
          {
            path: 'backend',
            name: 'settings-backend',
            component: loadView('backend/SettingsBackend'),
          },
          {
            path: 'teams',
            name: 'settings-teams',
            props: true,
            component: loadView('teams/Teams'),
            meta: {
              feature: 'teams',
              permission: 'teams',
            },
          },
          {
            path: 'tags',
            name: 'settings-tags',
            props: true,
            component: loadView('tags/Tags'),
            meta: {
              feature: 'tags',
              permission: 'tags',
            },
          },
          {
            path: 'custom-objects',
            name: 'settings-custom-objects',
            props: true,
            meta: {
              feature: 'tags',
            },
            redirect: { name: 'custom_objects' },
          },
          {
            path: 'permissions',
            name: 'settings-permissions',
            props: true,
            meta: {
              permission: 'update_users',
              feature: 'user_permissions',
            },
            component: loadView('permissions/AllUsersPermissions'),
          },
        ],
      },
      {
        path: 'teams/:team_id',
        name: 'settings-team-edit',
        props: true,
        meta: {
          feature: 'teams',
          permission: 'teams',
        },
        component: loadView('teams/TeamEdit'),
      },
      {
        path: 'integrations/:type',
        name: 'integration-edit',
        props: true,
        meta: {
          feature: 'integrations',
        },
        component: loadView('integrations/IntegrationEdit'),
      },
      {
        path: 'custom-objects/:id',
        name: 'settings-custom-object-edit',
        props: true,
        meta: { feature: 'custom_objects' },
        redirect: { name: 'custom-object-edit' },
      },
      {
        path: 'custom-objects/:id/import',
        name: 'settings-custom-object-import',
        props: true,
        meta: { feature: 'custom_objects' },
        redirect: { name: 'custom-object-import' },
      },
      {
        path: 'users/create',
        name: 'users-create',
        props: true,
        meta: { feature: 'users' },
        component: loadView('users/UserCreate'),
      },
      {
        path: 'users/:id',
        name: 'user-edit',
        props: true,
        meta: { feature: 'users' },
        component: loadView('users/UserEdit'),
      },
      {
        path: 'users/:user_id/permissions/:type?',
        name: 'user-permissions',
        props: true,
        meta: { feature: 'user_permissions' },
        component: loadView('permissions/SingleUserPermissions'),
      },
      {
        path: '/settings/account/plans',
        name: 'billing-plans',
        props: true,
        meta: { feature: 'account' },
        component: loadView('account/Plans'),
      },
    ],
  },
];

export default settingsRoutes;
